// audioRouter.js
// One mic, three destinations. Owns *where* clinician speech goes:
//   'sessions' — all selected visit recordings (current multi-record behavior)
//   'dictate'  — exactly one visit (patient drill-in "Dictate to this visit")
//   'agent'    — the Comprehend Live conversation channel; this speech is
//                excluded from visit transcripts so clinician<->agent talk
//                never contaminates a note.
//
// v1 routes by *state*, not by audio plumbing: the recorder keeps its own
// capture and the agent runtime keeps its own WebRTC track; this module is
// the single switch both consult. Follow-up (documented in
// docs/comprehend-live.md): collapse to a single getUserMedia capture fanned
// out via AudioContext so dictate mode can hard-exclude the other sessions.
import { Emitter } from './events';

export const ROUTES = {
  SESSIONS: 'sessions',
  DICTATE: 'dictate',
  AGENT: 'agent',
};

class AudioRouter {
  constructor() {
    this.route = ROUTES.SESSIONS;
    this.dictateConversationId = null;
    this.events = new Emitter();
  }

  onChange(cb) {
    return this.events.on('route', cb);
  }

  getRoute() {
    return this.route;
  }

  setRoute(route, { conversationId = null } = {}) {
    this.route = route;
    this.dictateConversationId =
      route === ROUTES.DICTATE ? conversationId : null;
    this.events.emit('route', {
      route: this.route,
      conversationId: this.dictateConversationId,
    });
  }

  /** While the agent channel is open (push-to-talk/wake word), visit chunks
   * uploaded in that window should be suppressed by the recorder. */
  agentChannelOpen() {
    return this.route === ROUTES.AGENT;
  }
}

export const audioRouter = new AudioRouter();
export default audioRouter;
